import ContactCards, {
  IContactCards,
} from '@organisms/ContactCards/ContactCards';

const ContentCards = (props: IContactCards) => <ContactCards {...props} />;

export default ContentCards;
